import React from 'react'
import './Spinner.css';

const Spinner = () => {
  return (
    <div>
        <div className="loader">Loading...</div>
    </div>
  )
}

export default Spinner